<lfx-full-card [title]="foundation.name" [details]="foundation.description" [color]="foundation.colorBand"
    [logo]="foundation.logoUrl" [showOverlay]="showOverlayOnFoundationCard" (action)="onViewFoundation()">

    <lfx-dev-analytics-summary [projects]="foundation.projects" [contributors]="$any(foundation.devAnalytics.contributors)"
        [contributions]="$any(foundation.devAnalytics.contributions)" [chartColor]="foundation.colorBand"
        (hoverEvent)="onHoverStatistics($event)">
    </lfx-dev-analytics-summary>

    <lfx-dev-analytics-line-chart [chartColor]="foundation.colorBand" [showLinechart]="linechartOption"
        [chartData]="foundation.devAnalytics">
    </lfx-dev-analytics-line-chart>

</lfx-full-card>
